import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//---------------------------------
//          ПОЛУЧЕНИЕ ДАННЫХ
//---------------------------------
//Tweeter
export async function getForecasterTweetsBookmarks() {
  const url = `${backendUrl}/api/forecasters/tweets/bookmarks/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении закладок твитов');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterTweetsBookmarks error:', error);
    throw error;
  }
}
//Telegram
export async function getForecasterTelegramBookmarks() {
  const url = `${backendUrl}/api/forecasters/telegram/bookmarks/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении закладок Telegram');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API getForecasterTelegramBookmarks error:', error);
    throw error;
  }
}


//---------------------------------
//          ОТПРАВКА ДАННЫХ
//---------------------------------
// --- TWEETER ---
//Добавить твит в закладки
export async function addForecasterTweetBookmark(tweet_id) {
  const url = `${backendUrl}/api/forecasters/tweets/${tweet_id}/bookmark/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при добавлении твита в закладки');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API addForecasterTweetBookmark error:', error);
    throw error;
  }
}
//Удалить твит из закладок
export async function removeForecasterTweetBookmark(tweet_id) {
  const url = `${backendUrl}/api/forecasters/tweets/${tweet_id}/bookmark/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при удалении твита из закладок');
    }

    return true;
  } catch (error) {
    console.error('API removeForecasterTweetBookmark error:', error);
    throw error;
  }
}

// --- TELEGRAM ---
//Добавить сообщение Telegram в закладки
export async function addForecasterTelegramBookmark(telegram_id) {
  const url = `${backendUrl}/api/forecasters/telegram/${telegram_id}/bookmark/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'POST',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при добавлении Telegram-сообщения в закладки');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API addForecasterTelegramBookmark error:', error);
    throw error;
  }
}
//Удалить сообщение Telegram из закладок
export async function removeForecasterTelegramBookmark(telegram_id) {
  const url = `${backendUrl}/api/forecasters/telegram/${telegram_id}/bookmark/`;

  try {
    const response = await fetchWithAuth(url, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при удалении Telegram-сообщения из закладок');
    }

    return true;
  } catch (error) {
    console.error('API removeForecasterTelegramBookmark error:', error);
    throw error;
  }
}